import Actions from 'redux/actions'
import type { CallAPIAction, Status } from 'api/types'
import { FailResponse } from 'api/evisaAPI/dlAPI'

type State = { errorMessage?: string } & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
  errorMessage: '',
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.VERIFY_UPDATE_MOBILE_OTP_ASYNC,
    Actions.VERIFY_UPDATE_MOBILE_OTP_SUCCESS,
    Actions.VERIFY_UPDATE_MOBILE_OTP_FAIL,
    {},
    FailResponse
  >,
): State => {
  switch (action.type) {
    case Actions.VERIFY_UPDATE_MOBILE_OTP_ASYNC:
    case Actions.VERIFY_UPDATE_MOBILE_OTP_SUCCESS: {
      return {
        ...state,
        ...action.status,
      }
    }
    case Actions.VERIFY_UPDATE_MOBILE_OTP_FAIL: {
      return {
        ...state,
        ...action.status,
        errorMessage: action.payload?.error.message || '',
      }
    }
    default:
      return state
  }
}
